import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
  ComponentFactoryResolver,
} from "@angular/core";
import { ModuleService } from "src/app/services/module.service";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { AuthService } from "src/app/services/auth.service";
import { HttpClient } from "@angular/common/http";
import { AddPageTitleComponent } from "../add-page-title/add-page-title.component";
import { Global } from "src/app/services/global";
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { BlockSettingsComponent } from "../block-settings/block-settings.component";
import { ActivatedRoute } from "@angular/router";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { PageApiGroupsService } from "../services/page-api-groups.service";
@Component({
  selector: "app-setting",
  templateUrl: "./setting.component.html",
  styleUrls: ["./setting.component.css"],
})
export class SettingComponent implements OnInit {
  @ViewChild("content", { read: ViewContainerRef, static: true })
  content: ViewContainerRef;
  childData;
  @Input() componentSettingsId;
  @Output() closeChildSettingsEmitter = new EventEmitter();
  @Input() selectedComponent: any;
  @Input() selectedBlock: any;
  @Input() page: any;
  /**
   * Full page layout — walked to collect every request group on the page.
   * Distinct from the local `pageLayout` scratch field below, which holds an
   * unrelated placeholder layout.
   */
  @Input() fullPageLayout: any;
  @Input() isChild = false;
  @Output() result = new EventEmitter<any>();
  @Output() openChildSetting = new EventEmitter();
  componetName: string;
  CSS: string;
  JS: string;
  settings: any;
  component: any;
  OrgComponent: any;
  siteCultures: any = [];
  culturesSettings: any = {};
  currentCulture: any;
  global: Global;
  selectedLanguageType: string;
  options: any = {
    indent_size: 4,
    indent_char: " ",
    eol: "\n",
    indent_level: 0,
    max_preserve_newlines: 10,
    wrap_line_length: 0,
    operator_position: "before-newline",
    brace_style: "collapse",
    indent_scripts: "normal",
    indent_with_tabs: true,
    preserve_newlines: true,
    end_with_newline: false,
    editorconfig: false,
    space_in_paren: false,
    space_in_empty_paren: false,
    jslint_happy: false,
    space_after_anon_function: false,
    space_after_named_function: false,
    unindent_chained_methods: false,
    break_chained_methods: false,
    keep_array_indentation: true,
    unescape_strings: false,
    e4x: false,
    comma_first: false,
    eval_code: false,
    space_before_conditional: true,
    "indent-inner-html": false,
  };
  jsPopupView: string;
  tempImports: any = {};
  indexToEdit: any;
  templateImports: any[] = [];
  modalRef: BsModalRef | null;
  settingsJson: string;
  viewSize = "Default";
  selectedBlockSizes: any = {};
  pageLayout: any = {};
  blockType: any;
  blockIndex: any = 0;
  setCssJsTo: any;
  Block: any;
  isComponentShared = false;
  constructor(
    global: Global,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private authService: AuthService,
    private modalService: BsModalService,
     private snotifyService: ToastrService,
    private moduleService: ModuleService,
    private siteService: SiteService,
    private cdr: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private pageApiGroups: PageApiGroupsService
  ) {
    this.global = global;
    
    if (this.isChild) this.cdr.detectChanges();
  }
  templateLayout: any = {};
  async ngOnInit() {
    let site = JSON.parse(localStorage.getItem("userData"));
    this.siteService
      .getUsedCulturs(site.DefaultSiteInfo.siteId)
      .subscribe((res: any) => {
        this.siteCultures = res;
        this.currentCulture = this.page.cultureId;
      });
console.log(this.selectedComponent,"sdfsdfsd")
    this.component = this.selectedComponent;
    this.Block = this.selectedBlock;
    this.OrgComponent = JSON.parse(JSON.stringify(this.selectedComponent));
    this.currentCulture = this.page.cultureId;
    this.templateImports = this.component.Imports ? this.component.Imports : [];
    this.jsPopupView = "code";
    this.templateLayout.containers = [
      {
        type: "full",
        rows: [
          { class: "", cols: [{ size: 12, component: { name: "header" } }] },
        ],
      },
      {
        type: "full",
        InnerPage: true,
        rows: [
          { class: "", InnerPage: true, cols: [{ InnerPage: true, size: 12 }] },
        ],
      },
    ];
    this.pageLayout.containers = [];
    // this.defaultSettings();

    //load default setting if no settings yet
    if (!this.component.setting || !Object.keys(this.component.setting).length ||typeof this.component.setting== "string") {
      //sondos
      this.component.setting = {};

      if (this.isChild && this.component.componentSettingsId) {
        //sondos
        let settings = await this.getCompSettings(
          this.page.id,
          this.component.componentSettingsId
        ).toPromise();
        if (settings && Object.keys(settings))
          this.component.setting = settings;
      }
      if (this.component.id && this.component.categoryId != 71) {
        this.httpClient
          .get("/Components/GetComponentByID/" + this.component.id)
          .subscribe((res: any) => {
            this.component.setting =
              res && res.settings ? JSON.parse(res.settings) : {};
            this.loadSetting();
          });
      } else if (this.component.id && this.component.categoryId == 71) {
        this.httpClient
          .get("/Elements/GetSharedElementById/" + this.component.id)
          .subscribe((res: any) => {
            let settings = JSON.parse(res.settings);
            settings.identifierCode = res.identifierCode;
            settings.isComponentShared = true;

            this.component.setting = settings || {};
            this.component.sharedSettings = true;
            this.isComponentShared = true;
            // this.checkIfShared();
            this.loadSetting();
          });
      } else {
        this.loadSetting();
      }
    } else if (this.selectedComponent.sharedStatus == 1) {
      this.isComponentShared = true;
      this.loadSetting();
    } else {
      if (this.component.sharedSettings && this.component.categoryId == 71) {
        //this.httpClient
        // .get("/Elements/GetSharedElementById/" + this.component.id)

        this.httpClient
          .get("/Elements/GetSharedElementById/" + this.component.id)
          .subscribe((res: any) => {
            // const sharedCompSettings = JSON.parse(res.settings);

            let sharedCompSettings = JSON.parse(res.settings);
            sharedCompSettings.identifierCode = res.identifierCode;
            sharedCompSettings.isComponentShared = true;

            this.component.setting = sharedCompSettings || {};

            this.isComponentShared = true;
            this.component.sharedSettings = true;
            this.component.setting = sharedCompSettings
              ? sharedCompSettings
              : {};
            this.loadSetting();
          });
      } else this.loadSetting();
    }
  }

  defaultSettings() {
    this.selectedBlock.sizes = this.selectedBlock.sizes || {};
    this.selectedBlock.type = this.selectedBlock.type || "full";
    this.selectedBlock.height = this.selectedBlock.height || "default";
    this.selectedBlock.imgAlign = this.selectedBlock.imgAlign || "none";
    this.selectedBlock.backgroundType =
      this.selectedBlock.backgroundType || "image";
    this.selectedBlock.repeatImage =
      this.selectedBlock.repeatImage || "no-repeat";
    this.selectedBlock.positionImage =
      this.selectedBlock.positionImage || "center";
    this.selectedBlock.sizeImage = this.selectedBlock.sizeImage || "cover";
    this.selectedBlock.marginTop = this.selectedBlock.marginTop || 0;
    this.selectedBlock.marginRight = this.selectedBlock.marginRight || 0;
    this.selectedBlock.marginBottom = this.selectedBlock.marginBottom || 0;
    this.selectedBlock.marginLeft = this.selectedBlock.marginLeft || 0;
    this.selectedBlock.paddingTop = this.selectedBlock.paddingTop || 0;
    this.selectedBlock.paddingRight = this.selectedBlock.paddingRight || 0;
    this.selectedBlock.paddingBottom = this.selectedBlock.paddingBottom || 0;
    this.selectedBlock.paddingLeft = this.selectedBlock.paddingLeft || 0;
    this.selectedBlock.borderTop = this.selectedBlock.borderTop || 0;
    this.selectedBlock.borderRight = this.selectedBlock.borderRight || 0;
    this.selectedBlock.borderBottom = this.selectedBlock.borderBottom || 0;
    this.selectedBlock.borderLeft = this.selectedBlock.borderLeft || 0;
    this.selectedBlock.borderRadiusTop =
      this.selectedBlock.borderRadiusTop || 0;
    this.selectedBlock.borderRadiusRight =
      this.selectedBlock.borderRadiusRight || 0;
    this.selectedBlock.borderRadiusBottom =
      this.selectedBlock.borderRadiusBottom || 0;
    this.selectedBlock.borderRadiusLeft =
      this.selectedBlock.borderRadiusLeft || 0;
    this.selectedBlock.textWeight = this.selectedBlock.textWeight || "default";
    this.selectedBlock.textTransform =
      this.selectedBlock.textTransform || "default";
    this.selectedBlock.textStyle = this.selectedBlock.textStyle || "default";
    this.selectedBlock.textDecoration =
      this.selectedBlock.textDecoration || "default";
    this.selectedBlock.borderType = this.selectedBlock.borderType || "none";
    this.selectedBlock.published = this.selectedBlock.published || false;
  }

  loadSetting() {
    // this.component.setting.js =
    //   this.component.setting.js || this.component.setting.JS;
    // this.component.setting.css =
    //   this.component.setting.css || this.component.setting.CSS;
    // this.component.setting.Imports = this.component.setting.Imports;
    console.log('bef',this.componetName)
    this.componetName =
      this.component.componentName.replace("Component", "") +
      "SettingsComponent";
      console.log('aft',this.componetName)
    // this.component.setting[this.currentCulture] = this.component.setting
    // this.siteCultures = this.authService.siteCultures;
    // if (this.siteCultures[0] !== "default")
    //   this.siteCultures.unshift("default");

    // if (this.siteCultures.length == 2) {
    //   this.currentCulture = this.siteCultures[1];
    // } else {
    //   //if no default setting defined , load it from first culture
    //   if (
    //     this.component.setting["default"] &&
    //     Object.keys(this.component.setting["default"]).length == 0
    //   ) {
    //     if (this.siteCultures.length > 1) {
    //       this.component.setting["default"] = this.component.setting[
    //         this.siteCultures[1]
    //       ];
    //     }
    //   } else if (!this.component.setting["default"]) {
    //     if (this.siteCultures.length > 1) {
    //       this.component.setting["default"] = this.component.setting[
    //         this.siteCultures[1]
    //       ]
    //         ? this.component.setting[this.siteCultures[1]]
    //         : JSON.parse(JSON.stringify(this.component.setting));
    //     }
    //   }
    // }

    //  this.setCultureSettings();

    this.culturesSettings = this.component.setting;
    this.loadSettingComp();
  }

  setCultureSettings() {
    // for (let index = 0; index < this.siteCultures.length; index++) {
    //   const e = this.siteCultures[index];
    //   var setting =
    //     this.component.setting[e] &&
    //       Object.keys(this.component.setting[e]).length > 0
    //       ? JSON.parse(JSON.stringify(this.component.setting[e]))
    //       : this.component.setting["default"]
    //         ? JSON.parse(JSON.stringify(this.component.setting["default"]))
    //         : JSON.parse(JSON.stringify(this.component.setting));
    //   this.culturesSettings[e] = setting;
    // }
    // this.component.setting = this.culturesSettings;
  }

 async loadSettingComp() {
    this.content.clear();
 



    // Create component
    const componentRef = this.moduleService.ComponentFactory[this.componetName];
    if (componentRef) {
    const componentFactory = this.componentFactoryResolver
    .resolveComponentFactory(componentRef);
 
    // const componentRef = this.content.createComponent(componentFactory);

   
      //create setting component
      const component: any = this.content.createComponent(componentFactory);;
      //sending @Input() values
      this.component.componentSettingsId =
        this.component.componentSettingsId ||
        Math.random().toString(36).substr(2, 9) + new Date().getTime();

      // Re-collect here too: the panel is also reached without going through
      // openSetting (child settings, culture reloads), and settings edited in a
      // previous open must show up in this one.
      const pageApiGroups = this.pageApiGroups.refresh(
        this.fullPageLayout ?? this.page,
      );

      component.instance.data = {
        page: this.page,
        component: this.component,
        /** Every request group configured anywhere on this page. */
        pageApiGroups,
        moduleService: this.moduleService,
        authService: this.authService,
        ComponentFactory: this.moduleService.ComponentFactory,
        enviroment: environment,
        dayGridPlugin: dayGridPlugin,
        interactionPlugin: interactionPlugin,
      };

      //save setting for each component
      component.instance.setting.subscribe((res) => {
        if (this.isChild) {
          if (res == 0) {
            this.closeChildSettingsEmitter.emit(true);
            return;
            // } else {
            //   if (this.component) {

            //     //sondos
            //     let data = {
            //       componetName: this.component.componentName,
            //       componentSettingsId: this.component.componentSettingsId
            //         ? this.component.componentSettingsId
            //         : v4() + Date.now(),

            //       lazyUi: true,
            //       settings: this.component.settings,
            //       alias: this.component.alias,
            //       pageVersionId: this.page.currentVersion.id,
            //     };

            //     this.saveComponentSettings(data);

            //     // call saveComponentBySettingsId(settingsId)

            //     // generate one if their is no settings id
            //     console.log("this.component", this.component);
            //     console.log("this.page", this.page);

            //     // on api success push child componentSettingsId , alias, componentName
            //     return;
            //   }
            // }
          }
        }
        if (res != 0) {
          if (
            this.component.sharedSettings &&
            this.component.categoryId == 71 &&
            this.component.sharedStatus !== 1
          ) {
            this.component.setting = JSON.parse(
              JSON.stringify(this.culturesSettings)
            );
            this.component.setting.js = this.JS;
            this.component.setting.css = this.CSS;

            // if (!this.component.sharedSettings) {
            //   this.httpClient
            //     .post("/Components/SaveComponentSettings/", {
            //       id: this.component.id,
            //       settings: JSON.stringify(this.culturesSettings),
            //     })
            //     .subscribe((res: any) => {
            //       this.result.emit({ result: "done", data: this.component });
            //     });
            // } else {
            var data = {
              id: this.component.id,
              settings: JSON.stringify(this.component.setting),
              cultureId: this.currentCulture ? this.currentCulture : null,
            };

            if (this.component.id !== 0 && this.component.sharedSettings) {
              this.httpClient
                .post("/Elements/UpdateSharedElementSettings/", data)
                .subscribe((res: any) => {
                  this.result.emit({
                    result: "updateShared",
                    data: this.component,
                  });
                });
            }
          } else {
            res.JS = this.JS;
            res.CSS = this.CSS;
            this.save();
          }
        } else this.close();
      });

      if (component.instance.viewChildSetting)
        component.instance.viewChildSetting.subscribe((res) => {
          if (res) {
            let val = JSON.parse(JSON.stringify(res));
            if (
              this.childData &&
              this.childData.componentSettingsId &&
              this.childData.componentSettingsId != val.componentSettingsId
            ) {
              this.childData = null;
              setTimeout(() => {
                this.childData = JSON.parse(JSON.stringify(val));
              }, 100);
            } else this.childData = JSON.parse(JSON.stringify(val));
            this.cdr.detectChanges();
          }
        });
      if (component.instance.myChilds) {
        component.instance.myChilds.subscribe((res) => {
          if (res) {
            let val = JSON.parse(JSON.stringify(res));
            this.component.setting.childsData = val;
          }
        });
      }
    } else console.log("No Component Found =>" + this.componetName);
  }

  AddImports() {
    if (this.indexToEdit == null) this.templateImports.push(this.tempImports);
    else
      this.templateImports[this.indexToEdit] = JSON.parse(
        JSON.stringify(this.tempImports)
      );
    this.indexToEdit = null;
    this.tempImports = {};
  }
  checkShared() {
    if (
      this.component.sharedSettings === undefined &&
      !this.isComponentShared
    ) {
      return true;
    }
    return false;
  }
  checkIfShared() {
    if (this.component.sharedSettings !== undefined && this.isComponentShared) {
      return true;
    }
    return false;
  }

  addStyleScript(data, type) {
    if (type == "css") {
      this.CSS = data;
      this.component.setting.css = data;
      this.culturesSettings.css = data;
    } else {
      this.JS = data;
      this.component.setting.js = data;
      this.culturesSettings.js = data;
    }
  }

  save() {
    this.component.setting = JSON.parse(JSON.stringify(this.culturesSettings));
    // this.component.currentCulture = this.currentCulture;
    this.result.emit({
      result: "done",
      data: this.component,
      data1: this.Block,
    });
    this.closeChildSettingsEmitter.emit(true);
  }
  async checkChildResult(event) {
    //sondos
    var childData = {
      componentName: event.data.componentName,
      componentSettingsId: event.data.componentSettingsId,

      lazyUi: true,
      settings: JSON.stringify(event.data.setting) || "{}",
      alias: event.data.alias || "",
      pageVersionId: this.page.currentVersion.id,
    };

    var res = await this.saveComponentSettings(childData).toPromise();
    if (res) {
      if (!this.component.setting.childsData)
        this.component.setting.childsData = {};
      this.component.setting.childsData[event.data.componentSettingsId] = {
        componentName: event.data.componentName,
        componentSettingsId: event.data.componentSettingsId,
        alias: event.data.alias || "",
      };

      this.openNotifySuccess("Something Went Wrong");
    }


  }
  resetSetting() {
    this.httpClient
      .get("/Components/GetComponentByID/" + this.component.id)
      .subscribe((res: any) => {
        this.component.setting =
          res && res.settings ? JSON.parse(res.settings) : {};
        this.loadSetting();
      });
  }

  // changeCulture() {
  //   this.page.currentCulture = this.currentCulture;
  //   this.component.setting = this.culturesSettings;
  //   this.loadSettingComp();
  // }

  // saveJSandCSS() {
  //   this.component.setting.JS = this.JS
  //   this.component.setting.CSS = this.CSS
  //   this.save();
  // }

  close() {
    this.result.emit({ result: "canceled", data: this.OrgComponent });
  }

  ShareComponent() {
    var component = JSON.parse(JSON.stringify(this.component));
    var category = {};
    const dialogRef = this.dialog.open(AddPageTitleComponent, {
      width: "30vw",
      data: { component: component, category: category },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        var data = {
          elementTypeId: "Component",
          elementId: this.component.id,
          settings: JSON.stringify(component.setting),
          cultureId: this.currentCulture,
          DataKey: this.component.componentName,
          Name: result.name,
        };
        // {
        //   DataKey: this.component.componentName,
        //   Name: result.name,
        //   Title: result.name,
        //   Settings: JSON.stringify(component.setting),
        //   category: { Id: result.category.id, Name: result.category.label },
        // };
        if (!this.selectedComponent) {
          this.selectedComponent = this.component;
        }

        this.selectedComponent.elementId = this.component.id;
        this.selectedComponent.name = data.Name;
        this.selectedComponent.ailasName = data.Name;
        this.selectedComponent.id = 0;
        this.selectedComponent.status = this.component.status;
        this.selectedComponent.componetTitle = "Shared";
        // this.selectedComponent.settings = this.component.settings;
        this.selectedComponent.sharedStatus = 1;
        this.selectedComponent.categoryId = 71;
        this.selectedComponent.sharedSettings = true;

        this.result.emit({
          result: "refresh",
          data: this.component,
          sharedData: data,
        });

        // this.httpClient
        //   .post("/Elements/ShareElement", data)
        //   .subscribe((res: any) => {
        //     if (res.id) {
        //       this.selectedComponent.name = res.name;
        //       this.selectedComponent.id = res.id;
        //       this.selectedComponent.status = res.status;
        //       this.selectedComponent.componetTitle = "Shared";
        //       this.result.emit({ result: "refresh", data: this.component });
        //     }
        //   });
      }
    });
  }

  closeChildsSettings() {
    this.childData = null;
  }

  // importSetting(cal) {
  //   if (
  //     this.culturesSettings[cal] &&
  //     this.culturesSettings
  //   ) {
  //     if (cal == "default") {
  //       this.openNotifyWarning(
  //         "Default settings will used for the culture " + this.currentCulture
  //       );
  //       this.culturesSettings = {};
  //       this.currentCulture = cal;
  //       this.component.setting = this.culturesSettings;
  //       this.loadSettingComp();
  //     } else {
  //       this.culturesSettings = JSON.parse(
  //         JSON.stringify(this.culturesSettings[cal])
  //       );
  //       this.component.setting = this.culturesSettings;
  //       this.loadSettingComp();
  //     }
  //   }
  // }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyWarning(message: string) {
    this.snotifyService.warning(message, "",{
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  beautify(type) {
    if (type == "css") {
      this.options["indent_size"] = 1;
      this.component.setting.css = this.global.beautify[type](
        this.component.setting.css,
        this.options
      );
    } else {
      this.options["indent_size"] = 4;
      this.component.setting.js = this.global.beautify[type](
        this.component.setting.js,
        this.options
      );
    }
  }

  openCode(templateJson) {
    this.settingsJson = JSON.stringify(this.culturesSettings, undefined, 4);
    this.modalRef = this.modalService.show(templateJson, {
      class: " modal-xl",
    });
  }

  savePageJson() {
    this.culturesSettings = JSON.parse(this.settingsJson);
    this.modalRef.hide();
  }

  openColSettings(b, index) {
    const dialogRef = this.dialog.open(BlockSettingsComponent, {
      data: { block: b, index: index, type: "col", from: "page" },
      width: "0vh",
      position: { right: "0" },
    });
  }

  saveBlockSetting(pop, form, block) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((f) => {
        form.controls[f].markAsTouched(true);
      });
      return;
    }
    block.sizes = form.value;
    pop.hide();
  }

  setSelectedBlockSizes(sizes) {
    this.selectedBlockSizes = sizes ? JSON.parse(JSON.stringify(sizes)) : {};
  }

  blockStatus(comp) {
    if (comp.blockStatus == 2 || comp.blockStatus == undefined) {
      comp.blockStatus = 1;
      this.openNotifySuccess("Published");
    } else {
      comp.blockStatus == 2;
      this.openNotifySuccess("Un-Published");
    }
  }

  saveComponentSettings(data) {
    return this.httpClient.post("/pages/UpsertComponentSettings", data);
  }

  getCompSettings(pageId: number, id: string) {
    return this.httpClient.get(`/Pages/GetComponentSettingsById/${id}`);
  }

  check() {
    return this.childData ? true : false;
  }
  get() {
    return this.childData;
  }
}
